import { Data, Effect } from "effect";
import { deploymentIdentity } from "@pima/web-api/deployment";

export class VersionCheckUnavailable extends Data.TaggedError(
  "VersionCheckUnavailable",
) {}

/** Static web-build metadata. This request bypasses the application API clients. */
export const readDeployedVersion = Effect.tryPromise({
  try: async (signal) => {
    const response = await fetch("/version.json", {
      cache: "no-store",
      credentials: "omit",
      signal,
    });
    if (!response.ok) throw new VersionCheckUnavailable();
    const body: unknown = await response.json();
    return deploymentIdentity(
      typeof body === "object" && body !== null && "version" in body
        ? body.version
        : null,
    );
  },
  catch: () => new VersionCheckUnavailable(),
}).pipe(
  Effect.timeoutFail({
    duration: "5 seconds",
    onTimeout: () => new VersionCheckUnavailable(),
  }),
);
